import {
  Typography,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Divider,
  CircularProgress,
  Grid,
} from "@material-ui/core";
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  presentFormatedData,
} from "../../../functionalComponents/dataFormatFunctions";
import WarningIcon from "@material-ui/icons/Warning";
const useStyles = makeStyles({
  table: {
    width: "100%",
    // minWidth: 650,
    "& .MuiTableCell-root": {
      // padding: "8px 12px",
      lineHeight: "1.2",
      // fontSize: "0.8rem",
      //   verticalAlign: "top",
      //   fontSize: "12px",
    },
    // "& .MuiTableRow-root": {
    //   height: "auto",
    // },
  },
  headerCell: {
    fontWeight: 500,
    backgroundColor: "#f5f5f5",
    // fontSize: "0.8rem",
  },
  grayRow: {
    backgroundColor: "#f5f5f5", // Lighter gray for even rows
  },
  spaceBetween: {
    lineHeight: "2",
  },
  lotNumbers: {
    display: "block", // Use block to ensure vertical stacking of lot numbers
    lineHeight: "1.5",
  },
  stickyHeaderRow: {
    position: "sticky",
    top: 0,
    zIndex: 1,
  },
  tableContainer: {
    maxHeight: "500px", // Set a fixed height for the table container
    overflow: "auto", // Enable
    width: "100%",
  },
});

export default function LotTable({ apiData, loading, error, batchDetails }) {
  const classes = useStyles();


  // const transformedData = apiData?.map((item) => ({
  //   sponsorCode: `${item.sponsorMaterialCode ?? "NA"} / ${
  //     item.sponsorMaterialName ?? "NA"
  //   }`,
  //   cmoCode: `${item.cmoMaterialCode ?? "NA"} / ${
  //     item.cmoMaterialName ?? "NA"
  //   }`,
  //   bomQuantity: item.componentQuantity ?? "NA",
  //   uom: item.uom ?? "NA",
  //   netAvailableQty: item.netQuantityAvailable ?? "NA",
  //   lotNumbers: item.LotNumberList?.map((lot) => lot.lotNumber ?? "NA") ?? [
  //     "NA",
  //   ],
  //   plannedAllocation: item.LotNumberList?.map(
  //     (lot) => lot.plannedAllocatedQuantity ?? "NA"
  //   ) ?? ["NA"],
  //   actualAllocation: item.LotNumberList?.map(
  //     (lot) => lot.actualAllocatedQuantity ?? "NA"
  //   ) ?? ["NA"], // Placeholder, update if actual data is provided
  //   quantityVariance: 0, // Placeholder for calculation logic
  //   lotsMismatch: "NO", // Placeholder, needs validation logic
  // }));

  const displayLoading = (
    <TableRow>
      <TableCell colSpan={9} align="center">
        <CircularProgress color="primary" thickness={7} />
      </TableCell>
    </TableRow>
  );

  const tableError = (
    <TableRow
      style={{
        border: "2px solid #FF0000",
        backgroundColor: "#FFF0F0",
        marginTop: "10px",
      }}
    >
      <TableCell colSpan={9} align="center">
        Something went wrong. Please try again later.
      </TableCell>
    </TableRow>
  );

  const noRecordsFoundMsgDisplay = (
    <TableRow>
      <TableCell colSpan={9} align="center">
        No records found
      </TableCell>
    </TableRow>
  );

  const mergeConsumptionWithPlanned = (
    allocationDetails,
    consumptionDetails
  ) => {
    // Create a map for quick lookup of consumed quantities by batch number
    const consumptionMap = new Map();

    consumptionDetails.forEach(
      ({ BomComponentConsumedQuantity, componentBatchNumber, expiryDate, netAvailableQuantity }) => {
        consumptionMap.set(componentBatchNumber, {
          BomComponentConsumedQuantity,
          expiryDate,
          netAvailableQuantity
        });
      }
    );

    // Merge planned allocation details with actual consumption
    let mergedDetails = allocationDetails.map(
      ({ plannedAllocatedQuantity, lotNumber, plannedLotAllocation, netAvailableQuantity, expiryDate }) => {
        const consumptionData = consumptionMap.get(lotNumber);
        return {
          plannedAllocatedQuantity,
          lotNumber,
          plannedLotAllocation,
          netAvailableQuantity,
          expiryDate,
          BomComponentConsumedQuantity: consumptionData?.BomComponentConsumedQuantity || null,
        };
      }
    );

    // Add any consumed batches that were not in planned allocation
    consumptionDetails.forEach(
      ({ BomComponentConsumedQuantity, componentBatchNumber, expiryDate, netAvailableQuantity }) => {
        if (
          !allocationDetails.some(
            ({ lotNumber }) => lotNumber === componentBatchNumber
          )
        ) {
          mergedDetails.push({
            plannedAllocatedQuantity: null,
            lotNumber: componentBatchNumber,
            plannedLotAllocation: null,
            netAvailableQuantity: netAvailableQuantity,
            expiryDate: expiryDate,
            BomComponentConsumedQuantity,
          });
        }
      }
    );

    return mergedDetails;
  };

  return (
    <Box style={{ marginTop: "1em" }}>
      <Typography variant="h6">
        <span
          style={{
            // fontWeight: "bold",
            borderBottom: "4px solid #a9a9a9",
            paddingBottom: "2px",
          }}
        >
          Con
        </span>
        sumption Details
      </Typography>

      {batchDetails?.bomConsumptionAddedIndicator ? (
        <TableContainer
          component={Paper}
          style={{ margin: "1rem 0" }}
          className={classes.tableContainer}
        >
          <Table className={classes.table} stickyHeader>
            <TableHead>
              <TableRow
                className={`${classes.grayRow} ${classes.stickyHeaderRow}`}
              >
                <TableCell className={classes.headerCell} align="left">
                  Material Code / Description
                </TableCell>
                <TableCell className={classes.headerCell} align="right">
                  BoM Quantity
                </TableCell>
                <TableCell className={classes.headerCell} align="left">
                  UoM
                </TableCell>
                <TableCell className={classes.headerCell} align="left">
                  Batch Numbers
                </TableCell>
                {/* Net Available Qty. is withdrawn from the post-consumption view — it no
                    longer applies once consumption is recorded. It still displays on the
                    pre-consumption table below (bomConsumptionAddedIndicator === false). */}
                <TableCell className={classes.headerCell} align="right">
                  Planned Batch Allocation
                </TableCell>
                <TableCell className={classes.headerCell} align="right">
                  Actual Batch Allocation
                </TableCell>
                <TableCell className={classes.headerCell} align="right">
                  Quantity Variance (%)
                </TableCell>
                <TableCell className={classes.headerCell} align="center">
                  Batches Mismatch
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading
                ? displayLoading
                : error
                  ? tableError
                  : apiData?.length === 0
                    ? noRecordsFoundMsgDisplay
                    : apiData?.map((row, index) => {
                      let allocation = mergeConsumptionWithPlanned(
                        row?.plannedLotNumberAllocationDetails || [],
                        row?.actualConsumptionDetails || []
                      );
                      return (
                        <React.Fragment key={index}>
                          <TableRow
                            className={index % 2 === 1 ? classes.grayRow : ""}
                          >
                            <TableCell
                              scope="row"
                              rowSpan={allocation.length > 1 && allocation.length}
                              align="left"
                            >
                              {row?.componentCode && row?.componentName
                                ? `${row.componentCode}/${row.componentName}`
                                : ""}
                            </TableCell>
                            <TableCell
                              scope="row"
                              rowSpan={allocation.length > 1 && allocation.length}
                              align="right"
                            >
                              {/* {row?.BOMQuantity || row?.BOMQuantity == 0
                                ? Number(row?.BOMQuantity).toFixed(3)
                                : "NA"} */}
                              {row?.componentQuantity || row?.componentQuantity == 0
                                ? Number(row?.componentQuantity).toFixed(3)
                                : ""}
                            </TableCell>
                            <TableCell
                              scope="row"
                              rowSpan={allocation.length > 1 && allocation.length}
                              align="left"
                            >
                              {row?.uom ? row?.uom : ""}
                            </TableCell>
                            <TableCell align="right">
                              {allocation.length > 0
                                ? allocation[0].lotNumber
                                  ? allocation[0].lotNumber
                                  : ""
                                : ""}
                            </TableCell>
                            <TableCell align="right">
                              {/* {allocation.length > 0
                                ? allocation[0].plannedLotAllocation
                                  ? Number(
                                    allocation[0].plannedLotAllocation
                                  ).toFixed(3)
                                  : 0
                                : 0} */}
                              {allocation.length > 0
                                ? allocation[0].plannedAllocatedQuantity
                                  ? Number(
                                    allocation[0].plannedAllocatedQuantity
                                  ).toFixed(3)
                                  : 0
                                : 0}
                            </TableCell>
                            <TableCell align="right">
                              {allocation.length > 0 &&
                                batchDetails?.bomConsumptionAddedIndicator
                                ? allocation[0].BomComponentConsumedQuantity
                                  ? Number(
                                    allocation[0].BomComponentConsumedQuantity
                                  ).toFixed(3)
                                  : 0
                                : ""}
                            </TableCell>

                            <TableCell
                              scope="row"
                              rowSpan={allocation.length > 1 && allocation.length}
                              align="right"
                            >
                              {!batchDetails?.bomConsumptionAddedIndicator
                                ? <span></span>
                                : row?.quantityVarianceValue === "NA" || row?.quantityVarianceValue === null || row?.quantityVarianceValue === undefined
                                  ? <span></span>
                                  : row?.quantityVarianceValue ||
                                    row?.quantityVarianceValue == 0
                                    ? (
                                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '4px' }}>
                                        <span
                                            // style={{
                                            //   color: row?.quantityVariancePresent ? "red" : "black"
                                            // }}
                                          >
                                          {row?.quantityVarianceValue % 1 !== 0
                                            ? Number(row?.quantityVarianceValue).toFixed(2)
                                            : row?.quantityVarianceValue}
                                        </span>
                                        {(row?.quantityVariancePresent) && (
                                          <WarningIcon fontSize='small' color='error' />
                                        )}
                                      </div>
                                    )
                                    : 0}
                            </TableCell>
                            <TableCell
                              scope="row"
                              rowSpan={allocation.length > 1 && allocation.length}
                              align="center"
                            >
                              {!batchDetails?.bomConsumptionAddedIndicator
                                ? ""
                                : row?.lotsMismatch
                                  ? (
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px' }}>
                                      <span>Yes</span>
                                      <WarningIcon fontSize='small' color='error' />
                                    </div>
                                  )
                                  : "No"}
                            </TableCell>
                          </TableRow>
                          {allocation.length > 1 &&
                            allocation.slice(1).map((val, i) => (
                              <TableRow
                                key={i}
                                className={index % 2 === 1 ? classes.grayRow : ""}
                              >
                                {/* <TableCell ></TableCell>
                          <TableCell ></TableCell>
                          <TableCell ></TableCell>
                          <TableCell ></TableCell> */}
                                <TableCell align="right">
                                  {val.lotNumber ? val.lotNumber : ""}
                                </TableCell>
                                <TableCell align="right">
                                  {/* {val.plannedLotAllocation
                                    ? Number(val.plannedLotAllocation).toFixed(3)
                                    : 0} */}
                                  {val.plannedAllocatedQuantity
                                    ? Number(val.plannedAllocatedQuantity).toFixed(3)
                                    : 0}
                                </TableCell>
                                <TableCell align="right">
                                  {!batchDetails?.bomConsumptionAddedIndicator
                                    ? ""
                                    : val.BomComponentConsumedQuantity ||
                                      val.BomComponentConsumedQuantity == 0
                                      ? Number(
                                        val.BomComponentConsumedQuantity
                                      ).toFixed(3)
                                      : 0}
                                </TableCell>
                                {/* <TableCell ></TableCell>
                          <TableCell ></TableCell> */}
                              </TableRow>
                            ))}
                        </React.Fragment>
                      );
                    })}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <TableContainer
          style={{ marginTop: "1rem", minHeight: "auto", maxHeight: "400px" }}
          component={Paper}
          className={classes.tableContainer}
        >
          <Table stickyHeader>
            {/* Table Head */}
            <TableHead>
              {/* Main header row */}
              <TableRow>
                <TableCell className={classes.headerCell}>
                  Material Code / description
                </TableCell>
                <TableCell className={classes.headerCell}>
                  BoM quantity
                </TableCell>
                <TableCell className={classes.headerCell}>UOM</TableCell>
                <TableCell className={classes.headerCell}>
                  Net available qty.
                </TableCell>
                <TableCell className={classes.headerCell}>
                  Material batch number
                </TableCell>
                <TableCell className={classes.headerCell}>
                  Planned allocated qty.
                </TableCell>
                <TableCell>Most recent change</TableCell>
              </TableRow>
            </TableHead>
            {/* Table Body */}
            {loading ? (
              <TableBody>
                <TableRow>
                  <TableCell colSpan={7}>
                    <div style={{ textAlign: "center" }}>
                      <CircularProgress color="primary" thickness={7} />
                    </div>
                  </TableCell>
                </TableRow>
              </TableBody>
            ) : error ? (
              <TableBody>
                <TableRow
                  style={{
                    border: "2px solid rgb(255,0,0)",
                    backgroundColor: "rgb(255,240,240)",
                    Opacity: 1,
                    textAlign: "center",
                    padding: "0.8rem",
                    fontSize: "0.875rem",
                  }}
                >
                  <TableCell
                    style={{ padding: "10px" }}
                    colSpan={7}
                    align="center"
                  >
                    Something went wrong. Please try again later.
                  </TableCell>
                </TableRow>
              </TableBody>
            ) : (
              <TableBody>
                {apiData?.length > 0 ? (
                  apiData.map((component, index) => (
                    <React.Fragment key={index}>
                      {(component?.lotNumberAllocationDetails && component?.lotNumberAllocationDetails.length > 0) ? (
                        component?.lotNumberAllocationDetails.map(
                          (lot, lotIndex) => (
                            <TableRow key={lotIndex}>
                              {/* Common columns should only appear in the first row */}
                              {lotIndex === 0 && (
                                <TableCell
                                  rowSpan={
                                    component?.lotNumberAllocationDetails?.length || 1
                                  }
                                >
                                  {presentFormatedData(
                                    component?.componentAllocationDetails
                                      ?.componentCode
                                  )}
                                  <br />
                                  {presentFormatedData(
                                    component?.componentAllocationDetails
                                      ?.componentName
                                  )}
                                </TableCell>
                              )}

                              {lotIndex === 0 && (
                                <TableCell
                                  rowSpan={
                                    component?.lotNumberAllocationDetails?.length || 1
                                  }
                                >
                                  {presentFormatedData(
                                    component?.componentAllocationDetails
                                      ?.componentQuantity
                                  )}
                                </TableCell>
                              )}

                              {lotIndex === 0 && (
                                <TableCell
                                  rowSpan={
                                    component?.lotNumberAllocationDetails?.length || 1
                                  }
                                >
                                  {presentFormatedData(
                                    component?.componentAllocationDetails?.uom
                                  )}
                                </TableCell>
                              )}

                              {/* {lotIndex === 0 && (
                                <TableCell
                                  rowSpan={
                                    component?.lotNumberAllocationDetails?.length || 1
                                  }
                                >
                                  {presentFormatedData(
                                    component?.componentAllocationDetails
                                      ?.netAvailableQuantity
                                  )}
                                </TableCell>
                              )} */}
                              {/* Lot-Specific Data - Net Available Qty per batch */}
                              <TableCell align="right">
                                {(lot?.netAvailableQuantity != null &&
                                  String(lot?.netAvailableQuantity).trim() !== "" &&
                                  !isNaN(Number(lot?.netAvailableQuantity)))
                                  ? Number(lot.netAvailableQuantity).toFixed(3)
                                  : ""}
                              </TableCell>
                              <TableCell>{lot?.lotNumber || ""}</TableCell>
                              <TableCell>
                                {/* {lot?.plannedAllocatedQuantity} */}
                                {(lot?.plannedAllocatedQuantity || lot.plannedAllocatedQuantity == 0) ? (
                                  lot.plannedAllocatedQuantity % 1 !== 0 ? Number(lot.plannedAllocatedQuantity).toFixed(3) : lot.plannedAllocatedQuantity
                                ) : ''
                                }
                              </TableCell>
                              <TableCell>
                                {component?.componentAllocationDetails
                                  ?.lastUpdatedDate
                                  ? new Date(
                                    component?.componentAllocationDetails?.lastUpdatedDate
                                  )
                                    .toLocaleString("en-GB", {
                                      day: "2-digit",
                                      month: "short",
                                      year: "numeric",
                                      hour: "2-digit",
                                      minute: "2-digit",
                                      second: "2-digit",
                                      hour12: false,
                                    })
                                    .replace(/([a-z]+)/i, (match) =>
                                      match.toUpperCase()
                                    )
                                  : ""}
                              </TableCell>
                            </TableRow>
                          )
                        )
                      ) : (
                        // If no lotNumberAllocationDetails exist, display one row with component info only
                        <TableRow>
                          <TableCell>
                            {presentFormatedData(
                              component?.componentAllocationDetails
                                ?.componentCode
                            )}
                            /
                            {presentFormatedData(
                              component?.componentAllocationDetails
                                ?.componentName
                            )}
                          </TableCell>

                          <TableCell>
                            {presentFormatedData(
                              component?.componentAllocationDetails
                                ?.componentQuantity
                            )}
                          </TableCell>
                          <TableCell>
                            {presentFormatedData(
                              component?.componentAllocationDetails?.uom
                            )}
                          </TableCell>
                          <TableCell>
                            {component?.componentAllocationDetails
                              ?.netAvailableQuantity
                              ? Number(
                                component?.componentAllocationDetails?.netAvailableQuantity.toFixed(
                                  3
                                )
                              ).toLocaleString("en-US")
                              : ""}
                          </TableCell>
                          <TableCell colSpan={3} align="center">
                            No batch allocation data
                          </TableCell>
                        </TableRow>
                      )}
                    </React.Fragment>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={7} align="center">
                      No data available
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            )}
          </Table>
        </TableContainer>
      )}
    </Box>
  );
}
